/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-12 10:51:12
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-12 14:19:53
 */

import config from "../../utils/config";
import axios from "../api";
import { IResponse } from "../Index";
import {
  IActivityInfo,
  IGamblingRegistData,
  IGamblingRegistParam,
  IGetActivityParams,
  IGetGamblingCountData,
  IGetGamblingCountParam,
} from "./interface";

class ActivityApi {
  /* 获取活动信息 */
  static getMyActivity(
    params: IGetActivityParams
  ): Promise<IResponse<IActivityInfo>> {
    return axios.post(
      `${config.baseUrl}/www/codoon_act/get_my_activity`,
      params
    );
  }
  /**
   * 站外探测登录态。401 不走全局跳登录，未登录时返回 null。
   */
  static getMyActivityIgnoreAuth(
    params: IGetActivityParams
  ): Promise<IResponse<IActivityInfo> | null> {
    return axios
      .post(`${config.baseUrl}/www/codoon_act/get_my_activity`, params, {
        validateStatus: (status: number) => status < 500,
      })
      .then((body: any) => {
        // 响应拦截器已解包为 body；401 时 status 不是 "OK"
        if (body && body.status === "OK") {
          return body as IResponse<IActivityInfo>;
        }
        return null;
      });
  }
  /* 未登录可访问的活动信息 */
  static getOpenMyActivity(
    params: IGetActivityParams
  ): Promise<IResponse<IActivityInfo>> {
    return axios.post(
      `${config.baseUrl}/open/www/codoon_act/get_my_activity`,
      params,
      {
        validateStatus: (status: number) => status < 500,
      }
    );
  }
  /* 对赌活动报名（生成订单号） */
  static gamblingRegist(
    params: IGamblingRegistParam
  ): Promise<IResponse<IGamblingRegistData>> {
    return axios.post(`${config.baseUrl}/www/codoon_act/pay`, params);
  }
  /* 查询对赌总完成人数、总奖金池 */
  static getGamblingCount(
    params: IGetGamblingCountParam
  ): Promise<IResponse<IGetGamblingCountData>> {
    return axios.post(
      `${config.baseUrl}/www/codoon_act/get_gambling_info`,
      params
    );
  }
}

export default ActivityApi;
